import { render, staticRenderFns } from "./priceControl.vue?vue&type=template&id=742ee0c5&scoped=true&"
import script from "./priceControl.vue?vue&type=script&lang=js&"
export * from "./priceControl.vue?vue&type=script&lang=js&"
import style0 from "./priceControl.vue?vue&type=style&index=0&id=742ee0c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ee0c5",
  null
  
)

export default component.exports